import {getThumbnail} from '../utils/media-utils';
import find from 'lodash/find';
import isArray from 'lodash/isArray';
import get from 'lodash/get';

export const getImageFromFirstStep = instruction => {
  if (instruction.steps && instruction.steps.length > 0) {
    const firstStepWithImage = find(instruction.steps, step => step.imageUrl);
    return firstStepWithImage ? firstStepWithImage.imageUrl : null;
  }
};

export const getInstructionCoverImage = instruction => {
  return instruction.imageUrl || getImageFromFirstStep(instruction);
};

export const getInstructionThumbnailImage = (instruction, returnPlaceholder, options) =>
  getThumbnail(getInstructionCoverImage(instruction), returnPlaceholder, options);

export const instructionHasImage = instruction => {
  return instruction && !!instruction.imageUrl && instruction.imageUrl !== '';
};

export const stepNoteTypes = {
  WARNING: 'WARNING',
  TIP: 'TIP',
  FIX: 'FIX',
  CUSTOM: 'CUSTOM'
};

export const getCustomIconLabel = (labelTranslations, currentLanguage) => {
  if (!isArray(labelTranslations) && !labelTranslations.length) {
    return '';
  }

  const localeObj = find(labelTranslations, {locale: currentLanguage});

  if (!localeObj) {
    return get(labelTranslations, '[0].translation');
  }

  return get(localeObj, 'translation', '');
};
